window.onload = function(e) {
    if (!sessionStorage.getItem('session')) {
        sessionStorage.setItem('session', true);
        document.querySelector("#preloaderScreen").classList.add("active")
        if( !/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
            preloaderVideo.setAttribute('autoplay', true)
            preloaderVideo.play()
        }
        setTimeout(function() {    
            // if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
            //     document.querySelector("#preloaderScreen").classList.add("hidden-mobile")
            // } else {
                document.querySelector("#preloaderScreen").classList.add("ended")
            // }
        }, 4000)
        setTimeout(function() {    
            $.magnificPopup.open({
                items: {
                    src: '#ordaModal'
                },
                type: 'inline',
                showCloseBtn: false,
            });
        }, 5500)
    } else {
        setTimeout(function() {
            document.querySelector("#preloaderScreen").classList.add("hidden")
        }, 1000)
    }
}
    
$('.orda-modal__close').click(function () {
    $.magnificPopup.close()
})

